import React from 'react';
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import { CHART_COLORS, formatCompact } from '../homeConfig';

const TooltipBox = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white border border-slate-200 shadow-md p-3 rounded-lg">
      <p className="text-xs font-semibold text-slate-700 mb-1">{label}</p>
      <p className="text-sm text-orange-600 font-medium">{formatCompact(payload[0].value)}</p>
      <p className="text-xs text-slate-400">{payload[0].payload.orders} orders</p>
    </div>
  );
};

const RevenueArea = ({ data }) => (
  <ResponsiveContainer width="100%" height={260}>
    <AreaChart data={data} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
      <defs>
        <linearGradient id="colorRev" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor={CHART_COLORS.revenue} stopOpacity={0.35} />
          <stop offset="95%" stopColor={CHART_COLORS.revenue} stopOpacity={0} />
        </linearGradient>
      </defs>
      <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" />
      <XAxis dataKey="label" tick={{ fill: '#64748b', fontSize: 12 }} axisLine={false} tickLine={false} />
      <YAxis tick={{ fill: '#64748b', fontSize: 12 }} axisLine={false} tickLine={false} tickFormatter={formatCompact} width={56} />
      <Tooltip content={<TooltipBox />} />
      <Area type="monotone" dataKey="revenue" stroke={CHART_COLORS.revenue} strokeWidth={2.5} fill="url(#colorRev)" />
    </AreaChart>
  </ResponsiveContainer>
);

export default RevenueArea;
